require('./bootstrap');

import { App, plugin, Link } from '@inertiajs/inertia-vue';
import Vue from 'vue';
import { route } from 'ziggy';
import { Ziggy } from './ziggy';
import VueMeta from 'vue-meta';
import Snotify, { SnotifyPosition } from 'vue-snotify';
import VTooltip from 'v-tooltip';
import moment from 'moment';
import Lang from './translations';
import VueCookie from 'vue-cookie';
import * as Sentry from '@sentry/vue';
import store from "./store";
import environment from "./environment";

Vue.config.productionTip = false;
Vue.use(VueMeta);
Vue.use(VueCookie);
Vue.use(Snotify, {toast: {position: SnotifyPosition.rightTop}});
Vue.use(VTooltip, {
    defaultTrigger: window.innerWidth > 768 ? 'hover focus click' : 'click'
});
Vue.use(plugin);

Vue.component('InertiaLink', Link);

require('./filters');
require('./prototypes');

Vue.mixin({ methods: { route: window.route } });
Vue.mixin({ methods: { route: (name, params, absolute) => route(name, params, absolute, {
    ...Ziggy,
    url: window.location.origin,
}) } });
Vue.mixin({ methods: { lang: (key, replacements = null) => Lang.get(key, replacements) } });

if (environment === 'production') {
    Sentry.init({
        Vue,
        dsn: 'https://dc050e9119b49b288dd6c83f35253d4c@sentry.skipwork.nl/8',

        // This sets the sample rate to be 10%. You may want this to be 100% while
        // in development and sample at a lower rate in production
        replaysSessionSampleRate: 0.3,

        // If the entire session is not sampled, use the below sample rate to sample
        // sessions when an error occurs.
        replaysOnErrorSampleRate: 1.0,

        integrations: [],

        environment: environment,
    });
}

moment.locale(Lang.getLocale());

const el = document.getElementById('app')

new Vue({
    store,
    metaInfo: {
        title: 'Laden...',
        titleTemplate: '%s | Sustainable Clothing Shop',
        meta: [
            { charset: 'utf-8' },
        ]
    },
    render: h => h(App, {
        props: {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: name => require(`./Pages/${name}`).default,
        },
    }),
}).$mount(el)

if (environment === 'production') {
    Sentry.addIntegration(new Sentry.BrowserTracing());
    Sentry.addIntegration(new Sentry.Replay());
}
